import type { FederationRuntimePlugin } from '@module-federation/enhanced/runtime';
import { RetryPlugin } from '@module-federation/retry-plugin';
const retryPlugin = (): FederationRuntimePlugin =>
	RetryPlugin({
		fetch: {
			retryDelay: 3000,
			retryTimes: 5,
			// TODO добавить вызов sentry, если есть проблема с загрузкой mf
			// fallback: () => {
			// 	return '';
			// },
		},
		script: {
			retryDelay: 3000,
			retryTimes: 5,
		},
	});
export default retryPlugin;
